// removed by extract-text-webpack-plugin
module.exports = {"container":"AdminSideMenu__container__3mfFV","separator":"AdminSideMenu__separator__35R9u"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Navigation/AdminSideMenu/AdminSideMenu.css
// module id = 567
// module chunks = 0